"use client";

import * as SliderPrimitive from "@radix-ui/react-slider";
import * as React from "react";

import { cn } from "@/utils/cn";

export const SliderSkeleton = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    trackStyle: React.CSSProperties | null;
  }
>(({ className, trackStyle, ...props }, ref) => {
  if (props.value === undefined || props.value.length === 0) {
    return null;
  }

  return (
    <div className={cn("relative w-full", className)}>
      <SliderPrimitive.Root
        ref={ref}
        className="relative flex w-full touch-none select-none items-center"
        {...props}
      >
        <SliderPrimitive.Track
          className="relative h-2 w-full grow overflow-hidden rounded-full bg-gray-200"
          style={trackStyle === null ? undefined : trackStyle}
        >
          <SliderPrimitive.Range
            className={cn(
              "absolute h-full",
              trackStyle === null ? "bg-gray-200" : "bg-transparent"
            )}
          />
        </SliderPrimitive.Track>
        {props.value.map((_, index) => (
          <SliderPrimitive.Thumb
            key={index}
            className="bg-background ring-offset-background focus-visible:ring-ring block h-5 w-5 rounded-full border-2 border-white bg-gray-900 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
          />
        ))}
      </SliderPrimitive.Root>
    </div>
  );
});

SliderSkeleton.displayName = "SliderSkeleton";
